import React, { useEffect, useState } from 'react'
import Modal from 'Common/Components/Modal';
// Formik
import { Common } from 'helpers/common';
import { Loader2, Pencil } from 'lucide-react';
import { ProductVariantType } from 'types/ProductVariantType';
import Select, { SelectInstance } from 'react-select';
import Cleave from "cleave.js/react";
import { ColorPallet } from 'pages/Ecommerce/Products/ColorPallet';
import { ProductImages } from './ProductImages';
import { ProductColor } from 'Common/Components/ProductColor';
import { ProductColorImage } from 'Common/Components/ProductColorImage';
import { ProductColorType } from 'types/ProductColorType';
import { addProductVariant, getProductVariantSku, updateProductVariant, addProductVariantImages, deleteProductVariantImages } from 'helpers/backend_helper';
import MultiColorBox from './MultiColorBox';
import { NO_DISCOUNT } from 'constants/settings';

type Props = {
    onHide: () => void;
    data: any,
    onSave: (result: any) => void, ProductSizes: any[], brandDiscount: number, productImageList: any[],
    productColorList: any[],
    productVariantList: any[],
    productSKU: string;
    combinedColorItems?: any[];
}

const AddProductVariant: React.FC<Props> = ({ onHide, data, onSave, ProductSizes, brandDiscount, productImageList, productColorList, productVariantList, productSKU, combinedColorItems }) => {

    const [isEdit, setIsEdit] = useState<boolean>(false);

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const commonHelper = new Common();
    const [errors, setErrors] = useState<any>({});

    const [productPrice, setProductPrice] = useState<ProductVariantType>(data);
    const [selectedProductSize, setSelectedProductSize] = useState<any>();
    const [showColorModal, setShowColorModal] = useState(false);
    const [productColors, setProductColors] = useState<any[]>(productColorList.map((item: any) => {
        return { ...item, selected: false };
    }
    ));
    const [selectedProductColor, setSelectedProductColor] = useState<any>();

    const [showImageModal, setShowImageModal] = useState(false);
    const [productImages, setProductImages] = useState<any[]>(productImageList);
    const [selectedProductImages, setSelectedProductImages] = useState<any[]>([]);

    const [productVariantSku, setProductVariantSku] = useState<any>();
    const [selectedItem, setSelectedItem] = useState<{ type: 'image' | 'color'; id: string | number } | null>(null);

    useEffect(() => {
        if (data?.id) {
            setIsEdit(true);
            if (data?.productsizesProductvariants) {
                setSelectedProductSize(ProductSizes.find(item => item.value === data.productsizesProductvariants.id));
                calculateSetPrice('', ''); // calculate NetPrice and SetPrice

                // Handle variant images - check for productvariantsVariantimages first, then fallback to imageUrl/imageName
                if (data?.productvariantsVariantimages && data.productvariantsVariantimages.length > 0) {
                    // Use the variant images data structure - include both name and id
                    const variantImageData = data.productvariantsVariantimages.map((variantImage: any) => ({
                        name: variantImage.name,
                        id: variantImage.id
                    }));

                    // Update productImages to mark the variant images as selected and include their ids
                    const updatedProductImages = productImages.map((item: any) => {
                        const variantImage = variantImageData.find((vImg: any) => vImg.name === item.name.trim());
                        return {
                            ...item,
                            selected: variantImage !== undefined,
                            variantImageId: variantImage?.id // Store the variant image id if it exists
                        };
                    });
                    setProductImages(updatedProductImages);

                    // Set selectedProductImages to the variant images
                    const selectedImages = updatedProductImages.filter(item => item.selected);
                    setSelectedProductImages(selectedImages);

                    // Update productPrice with all selected images
                    // if (selectedImages.length > 0) {
                    //     const imageUrls = selectedImages.map(img => img.preview).join(',');
                    //     const imageNames = selectedImages.map(img => img.name).join(',');
                    //     setProductPrice(prev => ({ ...prev, imageUrl: imageUrls, imageName: imageNames }));
                    // }
                } else if (data?.imageUrl) {
                    // Fallback to the old imageUrl/imageName structure
                    const imageNames = data?.imageName?.split(',').filter((name: string) => name.trim()) || [];

                    // Update productImages to mark the variant images as selected
                    const updatedProductImages = productImages.map((item: any) => ({
                        ...item,
                        selected: imageNames.includes(item.name.trim())
                    }));
                    setProductImages(updatedProductImages);

                    // Set selectedProductImages to the variant images
                    const selectedImages = updatedProductImages.filter(item => item.selected);
                    setSelectedProductImages(selectedImages);

                    // Update productPrice with all selected images
                    // if (selectedImages.length > 0) {
                    //     const imageUrls = selectedImages.map(img => img.preview).join(',');
                    //     const imageNames = selectedImages.map(img => img.name).join(',');
                    //     setProductPrice(prev => ({ ...prev, imageUrl: imageUrls, imageName: imageNames }));
                    // }
                }

                const updatedProductColors = productColors.map((item: ProductColorType) => ({
                    ...item,
                    selected: item.colorCode?.toLowerCase() === data?.colorCode?.toLowerCase()
                }));

                // Check if any color is selected
                const hasSelectedColor = updatedProductColors.some(item => item.selected);

                // Update state
                setProductColors(updatedProductColors);

                setSelectedProductColor({
                    colorCode: hasSelectedColor ? data?.colorCode || '' : '',
                    selected: true,
                    colorName: hasSelectedColor ? data?.colorName || '' : ''
                });
            }
        } else {

            if (!productPrice?.discountPercent || productPrice?.discountPercent === 0) {
                setProductPrice({ ...productPrice, discountPercent: brandDiscount });
                //loadProductVariantSku();
            }
        }

        console.log('productPrice', productPrice);
    }, [data])


    // const loadProductVariantSku = async () => {
    //     const response = await getProductVariantSku();
    //     setProductVariantSku(response.data[0]);
    //     setProductPrice({ ...productPrice, sku: response.data[0] });
    // }

    // Auto-select single image and color when creating new variant
    useEffect(() => {
        if (!data?.id && productImageList.length === 1) {
            const singleImage = productImageList[0];
            const updatedProductImages = productImages.map((item: any) => ({
                ...item,
                selected: item.name === singleImage.name
            }));
            setProductImages(updatedProductImages);
            setSelectedProductImages([singleImage]);
            setProductPrice(prev => ({
                ...prev,
                imageUrl: singleImage.preview,
                imageName: singleImage.name
            }));
        } else if (!data?.id && productImageList.length > 1) {
            // For multiple images, don't auto-select any by default
            const updatedProductImages = productImages.map((item: any) => ({
                ...item,
                selected: false
            }));
            setProductImages(updatedProductImages);
            setSelectedProductImages([]);
        }

        if (!data?.id && productColorList.length === 1) {
            const singleColor = productColorList[0];
            const updatedProductColors = productColors.map((item: ProductColorType) => ({
                ...item,
                selected: item.colorCode === singleColor.colorCode
            }));
            setProductColors(updatedProductColors);
            setSelectedProductColor({
                colorCode: singleColor.colorCode,
                selected: true,
                colorName: singleColor.colorName
            });
            setProductPrice(prev => ({
                ...prev,
                color: [singleColor.colorCode],
                colorCode: singleColor.colorCode,
                colorName: singleColor.colorName
            }));
        }
    }, [data?.id, productImageList.length, productColorList.length])


    const handleChange = (e: any, field: string) => {

        if (field === 'unitPrice' || field === 'packOf' || field === 'discountPercent' || field === 'mrp') {
            e.target.value = e.target.value.replace(/[^0-9.]/g, '');
        }
        setProductPrice({ ...productPrice, [field]: e.target.value });
    }


    const blankIfZero = (e: any, field: string) => {
        if (e.target.value != '' && parseInt(e.target.value) == 0) {
            e.target.value = '';
        }
    }
    const handleBlur = (e: any) => {

    }

    const checkDuplicateSizeColorCombination = (sizeId: string, colorCode: string, currentVariantId?: string) => {
        return productVariantList.find(x =>
            x.sizeId === sizeId &&
            x.colorCode?.toLowerCase() === colorCode?.toLowerCase() &&
            x.id !== currentVariantId
        );
    }

    const addRow = async () => {
        // add code to validate all fields
        try {
            // add validation for all the fields in productPrice. check if empty
            const errors: any = {};
            setErrors(errors);

            calculateSetPrice('', '');
            if (!productPrice.unitPrice || productPrice.unitPrice == 0) {
                errors.unitPrice = 'Required';
            }
            if (!productPrice.productsizesProductvariants.id) {
                errors.productsize = 'Required';
            }
            if (!productPrice.packOf || productPrice.packOf == 0) {
                errors.packOf = 'Required';
            }
            if (!productPrice.sku) {
                errors.sku = 'Required';
            }

            if (!selectedProductColor?.selected || !productPrice.colorCode) {
                errors.colorCode = 'Please select a color';
            }

                // if (selectedProductImages.length === 0) {
                //     errors.images = 'Please select at least one image';
                // }

            // Check for duplicate size and color combination
            if (productPrice.productsizesProductvariants.id && selectedProductColor?.colorCode) {
                const existingVariant = checkDuplicateSizeColorCombination(
                    productPrice.productsizesProductvariants.id,
                    selectedProductColor.colorCode,
                    productPrice.id
                );
                if (existingVariant) {
                    errors.duplicate = 'A variant with this size and color combination already exists. Please select a different size or color.';
                }
            }

            console.log(errors);

            if (Object.keys(errors).length > 0) {
                setErrors(errors);
                // Show toast notification for validation errors
                const errorMessages = Object.values(errors).join(', ');
                //commonHelper.showErrorMessage(`Please fix the following errors: ${errorMessages}`);
                commonHelper.showErrorMessage(`Please fix the validation errors`);

                return;
            }

            setIsSaving(true);
            productPrice.sizeId = productPrice.productsizesProductvariants.id;

            // Trim the SKU before saving
            const trimmedProductPrice = {
                ...productPrice,
                sku: productPrice.sku.trim()
            };

            const item = { ...trimmedProductPrice } as any;
            try {
                // Validation already handled above, proceed with save
                let isNew = item.id == '';
                if (!item.imageUrl) {
                    item.imageUrl = '';
                    item.imageName = '';
                }

                if (isNew) {

                    delete item.id;
                    item.syncedWithERP = false;
                    // add to db
                    const result = await addProductVariant(item);
                    item.id = result?.data.id;
                    item.isEdit = false;
                    console.log('Prod var save', result, item)
                } else {

                    delete item.color;
                    item.syncedWithERP = false;
                    const updateResult = await updateProductVariant(item);
                }

                // Save or update variant images (shared logic)
                try {
                    if (selectedProductImages.length > 0) {
                        for (const image of selectedProductImages) {
                            // Skip if image already has a variant image id (already exists in database)
                            if (image.variantImageId) {
                                console.log(`Skipping image ${image.name} as it already exists with id: ${image.variantImageId}`);
                                continue;
                            }
                            const imageData = {
                                name: image.name,
                                variantId: item.id,
                                url: image.name,
                                isActive: true
                            };
                            const result = await addProductVariantImages(imageData);
                            item.productvariantsVariantimages.push({ ...result.data, id: result.data.id });
                        }
                    }

                    // delete all images which is not selected and has variantImageId
                    const imagesToDelete = productImages.filter(item => !item.selected && item.variantImageId);
                    //console.log('imagesToDelete', imagesToDelete);
                    for (const image of imagesToDelete) {
                        await deleteProductVariantImages(image.variantImageId);
                        item.productvariantsVariantimages = item.productvariantsVariantimages.filter((item: any) => item.id !== image.variantImageId);
                    }


                } catch (error) {
                    console.error(isNew ? 'Error saving variant images:' : 'Error updating variant images:', error);
                    // Continue with save even if image save fails
                }

                onSave(item);
                console.log('on product variant save', item);

            } catch (error) {
                commonHelper.showErrorMessage('Some error occured. Please try again.');
                setIsSaving(true);
            }

        } catch (err) {
            console.log(err);
        }
    }


    const resetFields = () => {
        setProductPrice({ ...productPrice, unitPrice: 0, setPrice: 0, netPrice: 0, discountPercent: 0, mrp: 0, packOf: 1, inventory: 0, margin: 0, productsizesProductvariants: { name: '', id: '' }, colors: [], colorCode: '', colorName: '' });
        //loadProductColors();
    }


    const calculateSetPrice = (item: any, field: string) => {
        try {

            if (field in productPrice) {
                console.log('field', field, productPrice);
                (productPrice as any)[field] = (productPrice as any)[field]?.replace(/[^0-9.]/g, '');
                setProductPrice({ ...productPrice, [field]: (productPrice as any)[field] });
            }

            const unitPrice = productPrice.unitPrice || 0;
            const packOf = productPrice.packOf || 1;
            const discountPercent = productPrice.discountPercent || 0;
            const mrp = productPrice.mrp || 0;
            console.log(unitPrice, packOf, discountPercent);

            const discountValue = Math.round(((unitPrice / 100) * discountPercent) * 100) / 100.00;


            const netPrice = Math.round((unitPrice - discountValue) * 100) / 100;
            const setPrice = Math.round(netPrice * packOf * 100) / 100;

            setProductPrice({ ...productPrice, setPrice: setPrice, netPrice: netPrice, discountValue: discountValue });


            // productPrice.setPrice = setPrice;
            // productPrice.netPrice = netPrice;

            // discount can not be more than set price
            errors.discountPercent = '';
            errors.packOf = '';
            errors.unitPrice = '';
            errors.mrp = '';
            errors.sku = '';

            setErrors(errors);

            if (unitPrice <= 0 && field === 'unitPrice') {
                errors.unitPrice = 'Invalid Unit Price';
            }

            if (packOf <= 0 && field === 'packOf') {
                errors.packOf = 'Invalid Pack Of';
            }

            if (discountValue > unitPrice && field === 'discountPercent') {
                errors.discountPercent = 'Discount can not be > Unit Price';
            }

            // if (mrp > 0 && mrp < unitPrice && field === 'mrp') {
            //     errors.mrp = 'MRP can not be less than Unit Price';
            // }

            if (productPrice.sku == '' && field === 'sku') {
                errors.sku = '*';
            }

            // console.log(errors);
            // if (Object.keys(errors).length > 0) {
            //     setErrors(errors);
            // }



        } catch (err) {
        }
    }


    const onImageSaved = () => {
        setShowImageModal(false);
    }

    const onColorSaved = () => {
        setShowColorModal(false);
    }

    const handleColorChange = (color: ProductColorType) => {
        setSelectedProductColor({ colorCode: '', selected: false, colorName: '' });
        const prodColors = productColors.map((item: ProductColorType) => {
            if (item.colorCode === color.colorCode) {
                return { ...item, selected: !item.selected };
            } else {
                return { ...item, selected: false };
            }
        });

        setProductColors(prodColors);
        console.log(prodColors);

        let colors = prodColors?.find(item => item.selected == true);

        console.log('selected color', colors)

        setSelectedProductColor(colors || { colorCode: '', selected: false, colorName: '' });
        //productPrice.color= [colors];

        setProductPrice({ ...productPrice, color: colors ? [colors?.colorCode] : [], colorCode: colors?.colorCode || '', colorName: colors?.colorName || '' });

        // Validate size and color combination
        if (colors?.colorCode && productPrice.productsizesProductvariants?.id) {
            const existingVariant = productVariantList.find(x =>
                x.sizeId === productPrice.productsizesProductvariants.id &&
                x.colorCode?.toLowerCase() === colors.colorCode?.toLowerCase() &&
                x.id !== productPrice.id
            );
            if (existingVariant) {
                setErrors({ ...errors, colorCode: 'A variant with this size and color combination already exists' });
            } else {
                setErrors({ ...errors, colorCode: '' });
            }
        }

    }

    const handleImageChange = (imageName: string,toggle:boolean=true) => {
        const prodImages = productImages.map((item: any) => {
            if (item.name === imageName) {
                return { ...item, selected: toggle ? !item.selected : false };
            } else {
                return { ...item, selected: item.selected }; // Keep other selections
            }
        });

        setProductImages(prodImages);

        // Get all selected images
        const selectedImages = prodImages.filter(item => item.selected);
        setSelectedProductImages(selectedImages);

        // Update productPrice with all selected images
        // if (selectedImages.length > 0) {
        //     const imageUrls = selectedImages.map(img => img.preview).join(',');
        //     const imageNames = selectedImages.map(img => img.name).join(',');
        //     setProductPrice({ ...productPrice, imageUrl: imageUrls, imageName: imageNames });
        // } else {
        //     setProductPrice({ ...productPrice, imageUrl: '', imageName: '' });
        // }
    }


    const handleMultiColorChange = (checked: boolean) => {
        setSelectedProductColor({ ...selectedProductColor, selected: checked, colorCode: '', colorName: '' });
        setProductColors(productColors.map((item: ProductColorType) => {
            return { ...item, selected: false };
        }));

        setProductPrice({ ...productPrice, color: [''], colorCode: '', colorName: '' });

    }

    return (
        <React.Fragment>
            <Modal.Header className="bg-custom-200 dark:bg-custome-700 flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                <Modal.Title className="text-16">{!!isEdit ? "Variant" : "Variant"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto  bg-custom-50 dark:bg-custom-500/200">
                <div className=" grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                    <div className="xl:col-span-3">
                        <div className="flex items-center justify-between mb-0">
                            <label htmlFor="productsize" className="text-base font-medium">Variant Size</label>
                            {errors.productsize && (
                                <span className="text-sm text-red-500 ml-2">{errors.productsize}</span>
                            )}
                        </div>
                        <Select
                            className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            options={ProductSizes || []}
                            defaultValue={selectedProductSize}
                            value={selectedProductSize}
                            isSearchable={true} // To disable search
                            isDisabled={isEdit && selectedProductSize?.value}
                            name="productsize"
                            id="productsize"
                            onChange={e => {
                                const newSize = { name: e?.label || '', id: e?.value || '' };
                                setProductPrice({ ...productPrice, productsizesProductvariants: newSize });
                                // Validate size and color combination
                                if (newSize.id && selectedProductColor?.colorCode) {
                                    const existingVariant = checkDuplicateSizeColorCombination(newSize.id, selectedProductColor.colorCode, productPrice.id);
                                    if (existingVariant) {
                                        setErrors({ ...errors, productsize: 'A variant with this size and color combination already exists' });
                                    } else {
                                        setErrors({ ...errors, productsize: '' });
                                    }
                                } else {
                                    // Clear size error if no color is selected
                                    setErrors({ ...errors, productsize: '' });
                                }
                                console.log(e);
                            }}
                        />
                    </div>
                    <div className="xl:col-span-3">
                        <div className="flex items-center justify-between mb-0">
                            <label htmlFor="sku" className="text-base font-medium">SKU [Parent SKU({productSKU})]</label>
                            {errors.sku && (
                                <span className="text-sm text-red-500 ml-2">{errors.sku}</span>
                            )}
                        </div>
                        <div className="relative">
                            <input type="text"
                                min={0}
                                maxLength={15}
                                id="sku"
                                className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 pr-10"
                                placeholder="Enter SKU"
                                name="sku"
                                onChange={(e: any) => { handleChange(e, 'sku') }}
                                value={productPrice.sku || ""}
                            />
                            {productPrice.sku && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setProductPrice({ ...productPrice, sku: '' });
                                        setErrors({ ...errors, sku: '' });
                                    }}
                                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-slate-600 dark:text-zink-200 dark:hover:text-zink-100"
                                >
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* <div className="xl:col-span-3">
                        <label htmlFor="externalSku" className="inline-block mb-1 text-base font-medium">External SKU</label>

                        <input type="text"
                            min={0}
                            maxLength={15}
                            id="externalSku"
                            className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            placeholder="Enter External SKU"
                            name="externalSku"
                            onChange={(e: any) => { handleChange(e, 'externalSku') }}

                            value={productPrice.externalSku || ""}
                        ></input>
                    </div> */}

                    {NO_DISCOUNT ? <></> : (
                        <div className="xl:col-span-3">
                            <div className="flex items-center justify-between mb-0">
                                <label htmlFor="buyingPrice" className="text-base font-medium">Buying Price</label>
                                {errors.buyingPrice && (
                                    <span className="text-sm text-red-500 ml-2">{errors.buyingPrice}</span>
                                )}
                            </div>
                            <Cleave
                                placeholder="100.00"
                                options={{
                                    numeral: false,
                                    numeralThousandsGroupStyle: 'thousand'
                                }}
                                className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                name="buyingPrice"
                                id="buyingPrice"
                                autoComplete='off'
                                onKeyUp={(e: any) => { calculateSetPrice(e, 'buyingPrice') }}
                                onChange={(e: any) => { handleChange(e, 'buyingPrice') }}
                                onBlur={handleBlur}
                                onClick={(e: any) => { blankIfZero(e, 'buyingPrice') }}
                                value={productPrice.buyingPrice || ""}
                            />
                        </div>
                    )}

                    <div className="xl:col-span-3">
                        <div className="flex items-center justify-between mb-0">
                            <label htmlFor="unitPrice" className="text-base font-medium">Unit Price (Per Piece)</label>
                            {errors.unitPrice && (
                                <span className="text-sm text-red-500 ml-2">{errors.unitPrice}</span>
                            )}
                        </div>
                        <Cleave
                            placeholder=""
                            options={{
                                numeral: false,
                                numeralThousandsGroupStyle: 'thousand'
                            }}
                            className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            name="unitPrice"
                            id="unitPrice"
                            autoComplete='off'
                            onKeyUp={(e: any) => { calculateSetPrice(e, 'unitPrice') }}
                            onChange={(e: any) => { handleChange(e, 'unitPrice') }}
                            onBlur={handleBlur}
                            onClick={(e: any) => { blankIfZero(e, 'unitPrice') }}
                            value={productPrice.unitPrice || ""}
                        />
                    </div>

                    {NO_DISCOUNT ? <></> : (
                        <>
                            <div className="xl:col-span-3">
                                <div className="flex items-center justify-between mb-0">
                                    <label htmlFor="packOf" className="text-base font-medium">Pack Of (Quantity Per Set)</label>
                                    {errors.packOf && (
                                        <span className="text-sm text-red-500 ml-2">{errors.packOf}</span>
                                    )}
                                </div>
                                <Cleave id="packOf"
                                    className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    name="packOf"
                                    onClick={(e: any) => { blankIfZero(e, 'packOf') }}

                                    min={1}
                                    autoComplete='off'

                                    options={{
                                        numeral: false,
                                        numeralThousandsGroupStyle: 'thousand'
                                    }}
                                    maxLength={2}
                                    placeholder="6"
                                    onKeyUp={(e: any) => { calculateSetPrice(e, 'packOf') }}
                                    onChange={(e: any) => { handleChange(e, 'packOf') }}
                                    onBlur={handleBlur}
                                    value={productPrice.packOf || 1}
                                />
                            </div>
                            <div className="xl:col-span-3">
                                <div className="flex items-center justify-between mb-0">
                                    <label htmlFor="discountPercent" className="text-base font-medium">Discount(%)</label>
                                    {errors.discountPercent && (
                                        <span className="text-sm text-red-500 ml-2">{errors.discountPercent}</span>
                                    )}
                                </div>
                                <Cleave id="discountPercent" className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    placeholder="10"
                                    onKeyUp={(e: any) => { calculateSetPrice(e, 'discountPercent') }}
                                    onChange={(e: any) => { handleChange(e, 'discountPercent') }}
                                    onBlur={handleBlur}
                                    onClick={(e: any) => { blankIfZero(e, 'discountPercent') }}
                                    autoComplete='off'
                                    options={{
                                        numeral: true,
                                        // numeralDecimalScale: 2,
                                        // numeralPositiveOnly: true,
                                        // prefix: '%',
                                        // noImmediatePrefix: true,
                                        // rawValueTrimPrefix: true
                                    }}
                                    value={productPrice.discountPercent || ""}
                                    min={0}
                                    maxLength={2}
                                />
                                <label htmlFor="discountPercentBrand" className="inline-block mb-2 text-base text-xs italic">Brand Discount : {`${brandDiscount}%` || ""}</label>
                            </div>

                            <div className="xl:col-span-3">
                                <label htmlFor="netPrice" className="inline-block mb-1 text-base font-medium">Net Price</label>
                                <input type="number" id="netPrice" className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="₹0.00"
                                    disabled
                                    value={productPrice.netPrice || ""}
                                ></input>
                            </div>

                            <div className="xl:col-span-3">
                                <label htmlFor="setPrice" className="inline-block mb-1 text-base font-medium">Set Price/Pack Price </label>
                                <input type="number" id="setPrice" className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="₹0.00"
                                    disabled
                                    value={productPrice.setPrice || ""}
                                ></input>
                            </div>
                        </>
                    )}

                    <div className="xl:col-span-3">
                        <div className="flex items-center justify-between mb-0">
                            <label htmlFor="inventory" className="text-base font-medium">Inventory</label>
                            {errors.inventory && (
                                <span className="text-sm text-red-500 ml-2">{errors.inventory}</span>
                            )}
                        </div>
                        <Cleave id="inventory" className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            placeholder=""
                            onChange={(e: any) => { handleChange(e, 'inventory') }}
                            onBlur={handleBlur}
                            onClick={(e: any) => { blankIfZero(e, 'inventory') }}

                            value={productPrice.inventory || ""}
                            min={0}
                            autoComplete='off'
                            maxLength={5}
                            options={{
                                numeral: false,
                                numeralThousandsGroupStyle: 'thousand'
                            }}
                        />
                    </div>

                    {NO_DISCOUNT ? <></> : (
                        <>
                            <div className="xl:col-span-3">
                                <div className="flex items-center justify-between mb-0">
                                    <label htmlFor="mrp" className="text-base font-medium">MRP</label>
                                    {errors.mrp && (
                                        <span className="text-sm text-red-500 ml-2">{errors.mrp}</span>
                                    )}
                                </div>
                                <Cleave id="mrp"
                                    onKeyUp={(e: any) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                        calculateSetPrice(e, 'mrp');
                                    }}
                                    onChange={(e: any) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                        handleChange(e, 'mrp');
                                    }}
                                    onBlur={(e: any) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                        { handleBlur(e) };
                                    }}
                                    onClick={(e: any) => { blankIfZero(e, 'mrp') }}
                                    value={productPrice.mrp || 0}
                                    autoComplete='off'

                                    options={{
                                        numeral: false,
                                        numeralThousandsGroupStyle: 'thousand'
                                    }}
                                    min={0}
                                    maxLength={7}
                                    className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="₹0.00"
                                />
                            </div>
                            <div className="xl:col-span-3">
                                <div className="flex items-center justify-between mb-0">
                                    <label htmlFor="margin" className="text-base font-medium">Margin</label>
                                    {errors.margin && (
                                        <span className="text-sm text-red-500 ml-2">{errors.margin}</span>
                                    )}
                                </div>
                                <Cleave id="margin" className="form-input border-slate-400  dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="100"
                                    onChange={(e: any) => { handleChange(e, 'margin') }}
                                    onBlur={handleBlur}
                                    value={productPrice.margin || ""}
                                    onClick={(e: any) => { blankIfZero(e, 'margin') }}

                                    min={0}
                                    maxLength={5}
                                    autoComplete='off'

                                    options={{
                                        numeral: false,
                                        numeralThousandsGroupStyle: 'thousand'
                                    }}
                                />
                            </div>
                        </>
                    )}

                    {/* <div className="xl:col-span-3">
                        <label htmlFor="color" className="inline-block mt-5 text-base font-medium">Variant Color</label>
                        <div className="flex items-center justify-start">
                            {productColors.length > 1 ? (
                                 <MultiColorBox colors={productColors.map((color) => color.colorCode)}
                                 itemColor={selectedProductColor} onClick={(checked: boolean) => handleMultiColorChange(checked)} />
                            ) : (
                                <></>
                            )}
                          
                            <ProductColor
                                id="varcolors"
                                key="varcolorMain"
                                onStatusChange={handleColorChange}
                                productColors={productColors}
                                onColorSaved={() => console.log('color saved')}
                                showColorPallet={false}
                            ></ProductColor>
                        </div>
                        {errors.colorCode ? (
                            <div id="colorCode-error" className="mt-1 text-sm text-red-500">{errors.colorCode}</div>
                        ) : null}
                    </div> */}


                    {/* Additional Product Images with Colors Section */}
                    <div className="xl:col-span-12">
                        <div className="flex items-center justify-between mb-0">
                            <label htmlFor="product-images-colors" className="inline-block mt-5 text-base font-medium">
                                Variant Color <span className="text-red-500">*</span>
                            </label>
                            {errors.colorCode && (
                                <span className="text-sm text-red-500 ml-2">{errors.colorCode}</span>
                            )}
                        </div>

                        <div className={errors.colorCode ? 'border-1 border-red-300 rounded-md p-2' : ''}>
                            <ProductColorImage
                                id="product-images-colors"
                                combinedItems={combinedColorItems || []}
                                showEditButton={false}
                                selectedItem={selectedItem}
                                selectedColorCode={productPrice.colorCode}
                            onItemClick={(item) => {
                                const { type, id, colorCode, colorName, imageName } = item;
                                const isSameColor = colorCode === selectedProductColor?.colorCode;
                                
                                // Clear selection if same color is clicked
                                if (isSameColor) {
                                    const updates = {
                                        colorCode: '',
                                        colorName: '',
                                        imageUrl: '',
                                        imageName: ''
                                    };
                                    
                                    setSelectedProductColor(null);
                                    setSelectedItem(null);
                                    setProductPrice(prev => ({ ...prev, ...updates }));
                                    
                                    // Deselect image if it's an image type
                                    if (type === 'image') {
                                        const selectedImage = productImages[id as number];
                                        selectedImage && handleImageChange(selectedImage.name, false);
                                    }
                                    return;
                                }
                                
                                // Handle new selection
                                const newSelection = {
                                    colorCode,
                                    selected: true,
                                    colorName
                                };
                                
                                const priceUpdates = {
                                    color: [colorCode],
                                    colorCode,
                                    colorName
                                };
                                
                                setSelectedItem({ type, id });
                                setSelectedProductColor(newSelection);
                                
                                // Add image-specific updates
                                if (type === 'image') {
                                    const selectedImage = productImages[id as number];
                                    if (selectedImage) {
                                        handleImageChange(selectedImage.name, true);
                                        Object.assign(priceUpdates, {
                                            imageUrl: imageName,
                                            imageName
                                        });
                                    }
                                }
                                
                                setProductPrice(prev => ({ ...prev, ...priceUpdates }));
                            }}
                        />
                        </div>
                    </div>

                    <div className="xl:col-span-12">
                        <div className="flex items-center justify-between mb-2">
                            <label htmlFor="color" className="inline-block mt-5 text-base font-medium">Variant Images (Optional)</label>
                            <div className="flex items-center gap-2">
                                {selectedProductImages.length > 0 && (
                                    <span className="text-sm text-slate-500 dark:text-zink-400">
                                        {selectedProductImages.length} image{selectedProductImages.length !== 1 ? 's' : ''} selected
                                    </span>
                                )}
                                {/* Image errors removed since images are now optional */}
                            </div>
                        </div>

                        <div className="flex items-center justify-start" style={{ flexDirection: 'row', display: 'flex', flexWrap: 'wrap' }}>
                            {productImages?.map((file: any, index: number) => (
                                <div
                                    style={{ marginRight: 10 }}
                                    className={`border rounded border-slate-400 dark:border-zink-500 ${file.selected ? 'ring-2 ring-custom-500 bg-custom-50 dark:bg-custom-900/20' : ''}`}
                                    key={"dropzone-preview-list2" + index}
                                >
                                    <div className="p-2 text-center">
                                        <div>
                                            <div className="p-1 mx-auto rounded-md size-20 bg-slate-200 dark:bg-zink-600">
                                                <img className="block w-full h-full rounded-md" src={file.preview} alt={file.name} />
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <input type="checkbox" checked={file.selected} onChange={() => handleImageChange(file.name)} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>


                </div>
                {/* <div>
                    {Object.keys(errors).length > 0 && (
                        <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-md dark:bg-red-900/20 dark:border-red-800">
                            <div className="flex items-center">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
                                        Please fix the following errors:
                                    </h3>
                                    <div className="mt-2 text-sm text-red-700 dark:text-red-300">
                                        <ul className="list-disc pl-5 space-y-1">
                                            {Object.entries(errors).map(([field, message]) => (
                                                <li key={field}>
                                                    <strong className="capitalize">{field.replace(/([A-Z])/g, ' $1').trim()}:</strong> {String(message)}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div> */}

                <div className="border-t border-slate-200 dark:border-zink-500 flex justify-end gap-2 mt-4 pt-5">
                    <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={onHide}>Cancel</button>

                    {!isSaving ?
                        <button type="button"
                            onClick={() => addRow()}
                            className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                            {"Save"}

                        </button>
                        : <button type="button" disabled className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                            <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                            Saving...
                        </button>
                    }

                </div>

                {
                    showColorModal && (
                        <Modal show={showColorModal} onHide={() => { setShowColorModal(false) }} id="defaultModal" modal-center="true"
                            className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                            dialogClassName="w-screen md:w-[40rem] bg-white shadow rounded-md dark:bg-zink-600">
                            <ColorPallet key="colorPalletModal"
                                productColors={productColors}
                                onStatusChange={handleColorChange}
                                onColorSaved={() => { setShowColorModal(false); onColorSaved() }}
                            ></ColorPallet>
                        </Modal>
                    )}

                {
                    showImageModal && (
                        <Modal show={showImageModal} onHide={() => { setShowImageModal(false) }} id="defaultModal" modal-center="true"
                            className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                            dialogClassName="w-screen md:w-[40rem] bg-white shadow rounded-md dark:bg-zink-600">
                            <ProductImages key="colorPalletModal"
                                productImages={productImages}
                                onStatusChange={handleImageChange}
                                onImageSaved={() => { setShowImageModal(false); onImageSaved() }}
                            ></ProductImages>
                        </Modal>
                    )}


            </Modal.Body>
        </React.Fragment >
    )
}

export default AddProductVariant;